import { render, staticRenderFns } from "./AdminPostGroupForm.vue?vue&type=template&id=5a6a63fd"
import script from "./AdminPostGroupForm.vue?vue&type=script&lang=js"
export * from "./AdminPostGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports